import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m9.518 21.6-.027-8.727H6V9.382h3.49V7.2c0-3.24 2.007-4.8 4.896-4.8 1.384 0 2.574.103 2.92.149v3.385h-2.004c-1.571 0-1.875.748-1.875 1.843v1.605H18l-1.745 3.49h-2.828V21.6z" }));
const SvgFacebookSso = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgFacebookSso;
